import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

require('./SpendAnalyticsOverviewPage.less');
require('@antv/data-set');

const SpendAnalyticsOverviewPage: FC<any> = ({
	history,
	userType,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/analytics/spend/overview/${key}`),
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{ key: 'problemTypes', name: 'Problem Types' },
		{ key: 'vendors', name: 'Suppliers' },
		{ key: 'locations', name: 'Locations' },
	];

	return (
		<>
			<Route
				path={`/${userType}/analytics/spend/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/analytics/spend/overview/problemTypes`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Spend Analytics"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="spendAnalyticsPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, () => ({}))(SpendAnalyticsOverviewPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
